import { useContext, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import AppContext from "../contexts/appContext";
import servicesIcon from "../assets/images/services-image.png";
import { Helmet } from "react-helmet";
import OurProcess from "../components/OurProcess";
import HowItWorks from "../components/HowItWorks";
import ClientsReviews from "../components/ClientsReviews";

export default function Services() {
  const { menu } = useContext(AppContext);

  const { serviceId } = useParams();

  const menuService = useMemo(() => {
    if (menu) {
      return menu.filter((ser) => ser?.id == serviceId)[0];
    }
    return null;
  }, [menu, serviceId]);

  const service = useMemo(() => {
    if (menuService) {
      return menuService.name.toUpperCase();
    }
    return "";
  }, [menuService]);

  const serviceCategories = useMemo(() => {
    if (menuService) {
      return menuService.category;
    }
    return null;
  }, [menuService]);

  return (
    <>
      <Helmet>
        <title>Dailysocialboost | {service || "Service"}</title>
      </Helmet>
      <section className="container mx-auto px-12">
        <div className="flex flex-col lg:flex-row items-center justify-between">
          <div className="grow">
            <h2 className="text-5xl font-bold">
              Buy <span className="text-purple-650">{service} Services</span>
            </h2>
            <p className="my-10 font-semibold">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque eget ullamcorper ex,
              dignissim egestas enim.
            </p>
            <div className="flex flex-col lg:flex-row gap-2">
              {serviceCategories
                ? serviceCategories.map((category) => (
                    <Link
                      to={`/buy-${service.toLowerCase()}-${category.name.toLowerCase()}/${serviceId}/${
                        category.id
                      }/${category.subcategory[0]?.id}`}
                      key={`${serviceId}/${category.id}/${category.subcategory[0]?.id}`}
                      id={`${category?.name}`}
                      className="my-2 px-8 py-3 uppercase rounded-3xl text-white bg-purple-650 shadow-xl lg:hover:opacity-90 transition-all"
                    >
                      {category?.name}
                    </Link>
                  ))
                : null}
            </div>
          </div>
          <div className="flex-none">
            <img className="mt-10" src={servicesIcon} alt="Services" />
          </div>
        </div>
      </section>
      <OurProcess />
      <HowItWorks />
      {/* <section className="container mx-auto"> */}
      <ClientsReviews />
      {/* </section> */}
    </>
  );
}
